import { z } from "zod";

/**
 * Which supervisors of the supervisor org get an account's email alerts and comment emails, and
 * see it under "My accounts" (`selected` only).
 */
export const assignedSupervisorsSchema = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("all") }),
  z.object({ mode: z.literal("none") }),
  z.object({ mode: z.literal("selected"), uids: z.array(z.string()).min(1) }),
]);
export type AssignedSupervisors = z.infer<typeof assignedSupervisorsSchema>;

export const isAssignedSupervisor = (assignedSupervisors: AssignedSupervisors, uid: string) => {
  switch (assignedSupervisors.mode) {
    case "all":
      return true;
    case "none":
      return false;
    case "selected":
      return assignedSupervisors.uids.includes(uid);
  }
};
